import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfiguredAlert, ConfiguredAlertListItem, CreateConfiguredAlertRequest, UpdateConfiguredAlertRequest } from '@models/index';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({ providedIn: 'root' })
export class ConfiguredAlertsService {
  private readonly url = `${environment.bffUrl}/monitoring/configured-alerts`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<ConfiguredAlertListItem[]> {
    return this.http.get<ConfiguredAlertListItem[]>(this.url);
  }

  getOne(id: string): Observable<ConfiguredAlert> {
    return this.http.get<ConfiguredAlert>(`${this.url}/${id}`);
  }

  add(dto: CreateConfiguredAlertRequest): Observable<ConfiguredAlert> {
    return this.http.post<ConfiguredAlert>(this.url, dto);
  }

  update(id: string, dto: UpdateConfiguredAlertRequest): Observable<ConfiguredAlert> {
    return this.http.put<ConfiguredAlert>(`${this.url}/${id}`, dto);
  }

  delete(id: string, alertTypeId: string): Observable<void> {
    return this.http.delete<void>(`${this.url}/${id}`, { params: { alertTypeId } });
  }

  subscribe(id: string): Observable<void> {
    return this.http.put<void>(`${this.url}/${id}/subscribers`, {});
  }
}
